export enum AccordionStatus {
  completed = 'Completed',
  submitted = 'Pending Other Owner',
  pending = 'Action Required',
  Completed = 'Completed',
  PendingOtherOwner = 'Pending Other Owner',
  ActionRequired = 'Action Required',
}
